import QrCodeIcon from '@mui/icons-material/QrCode';
import { Grid, Typography, useTheme } from '@mui/material';
import useFormatNumber from 'hooks/useFormatNumber';
import { NavLink } from 'react-router-dom';
import { routeFeatures } from 'routes/navigate';
import { Wallet } from 'types/wallet';
import AddressCopy from './AddressCopy';
import { truncateAddress, getCoinImageUrl } from 'helpers';

const sizeCoinImage = 18;

export interface CoinCardProps {
    data: Wallet;
    onClick: (symbol: string) => void;
    selected?: boolean;
    isLoading: boolean;
}

const address = '0x8f13205bF578afc50B5bf995C2e68BD128BdD4D6';

const CoinCard = ({ data: { symbol, balance, priceUsd }, selected, onClick, isLoading }: CoinCardProps) => {
    const theme = useTheme();
    const { fFiat, fCrypto } = useFormatNumber();
    return (
        <Grid
            container
            flexWrap="nowrap"
            gap={1}
            sx={{
                borderWidth: 1,
                borderStyle: 'solid',
                borderColor: theme.palette.grey[300],
                padding: 1.5,
                borderRadius: 2,
                transition: 'all 0.25s',
                ...(isLoading
                    ? { backgroundColor: theme.palette.grey[100] }
                    : {
                          backgroundColor: selected ? theme.palette.primary.light : 'unset',
                          ':hover': {
                              backgroundColor: theme.palette.primary.light
                          }
                      }),
                cursor: 'pointer'
            }}
            onClick={() => onClick(symbol)}
        >
            <Grid item>
                <Grid container flexDirection="column" alignItems="center">
                    <Grid item>
                        <NavLink to={routeFeatures.walletDetail(symbol)}>
                            <img src={getCoinImageUrl(symbol)} width={sizeCoinImage} height={sizeCoinImage} alt="" loading="lazy" />
                        </NavLink>
                    </Grid>
                    <Grid item fontSize={sizeCoinImage}>
                        <QrCodeIcon fontSize="inherit" />
                    </Grid>
                </Grid>
            </Grid>
            <Grid item flex={1}>
                <Grid container flexDirection="column" alignItems="start" justifyContent="space-between" height="100%">
                    <Grid item>
                        <Typography variant="h5">{symbol}</Typography>
                    </Grid>
                    <Grid item>
                        <AddressCopy text={address}>{truncateAddress({ address })}</AddressCopy>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item>
                <Grid container flexDirection="column" alignItems="end" justifyContent="space-between" height="100%">
                    <Grid item>
                        <Typography variant="h5">
                            {fCrypto(balance)} {symbol}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Typography variant="h5" fontWeight={300} sx={{ color: theme.palette.grey[500] }}>
                            {fFiat(priceUsd)}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default CoinCard;
